import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class IndexRoute extends Route
{
	@service router;

	redirect(model, transition)
	{
		this.router.transitionTo('event.details', model);
	}
}

